export async function injectHtml(container, html, delay = 0) {
	try {
		await injectHtmlIntoEntity($(container), html, delay);

		return true;
	} catch (ex) {
		console.error(ex);
		return false;
	}
}

export async function injectHtmlIntoEntity(containerEntity, html, delay = 0) {
	try {
		// Inject HTML into DOM.
		containerEntity.html(html);

		if (delay) {
			const promise = new Promise((resolve, reject) => {
				setTimeout(() => resolve(true), delay);
			});
			await promise;
		}

		return true;
	} catch (ex) {
		console.error(ex);
		return false;
	}
}
